/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as w from "react";
import { MS_PER_DAY as D } from "@progress/kendo-date-math";
import { MS_PER_MINUTE as m } from "../constants/index.mjs";
const v = (M, { step: t }, { groups: l, ranges: z }) => {
  const i = [];
  return l.forEach((E) => {
    z.forEach((o) => {
      const s = o.zonedStart, f = o.zonedEnd, r = f.timezoneOffset - s.timezoneOffset;
      for (let e = s.clone(), a = 0, d = r < 0 ? r * m * -1 : 0; e.getTime() < f.getTime(); a++, e = e.addTime(t)) {
        const T = w.createRef(), n = e.clone(), c = e.addTime(t), S = (c.timezoneOffset - n.timezoneOffset) * m, _ = t <= Math.abs(S);
        d && _ && (d -= t, e = e.addTime(-t));
        const R = new Date(n.getTime()), h = new Date(c.getTime()), u = {
          _ref: T,
          index: a,
          end: h,
          start: R,
          zonedStart: n,
          zonedEnd: c,
          range: o,
          group: E,
          items: [],
          isAllDay: D <= t
        };
        i.push(u);
      }
    });
  }), i;
};
export {
  v as toSlots
};
